var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpPcMeetingIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87373 7.79175C9.21566 8.00077 9.39567 8.23788 9.39567 8.47925C9.39567 8.72061 9.21566 8.95772 8.87373 9.16675C8.5318 9.37577 8.04 9.54935 7.44775 9.67003C6.85551 9.79071 6.1837 9.85425 5.49984 9.85425C4.81598 9.85425 4.14416 9.79071 3.55192 9.67003C2.95968 9.54935 2.46788 9.37577 2.12595 9.16675C1.78402 8.95772 1.604 8.72061 1.604 8.47925C1.604 8.23789 1.78402 8.00077 2.12595 7.79175",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 4.58325C8.9375 6.68177 6.84329 8.15705 5.92405 8.70353C5.66101 8.8599 5.33899 8.8599 5.07595 8.70353C4.15671 8.15705 2.0625 6.68177 2.0625 4.58325C2.0625 2.52075 3.72809 1.14575 5.5 1.14575C7.33333 1.14575 8.9375 2.52075 8.9375 4.58325Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.49984,
    cy: 4.58333,
    r: 1.58333,
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpPcMeetingIconWhite);
export default __webpack_public_path__ + "static/media/cp-pc-meeting-icon-white.709860513bb6bf5ab7dd71a60a3a8aee.svg";
export { ForwardRef as ReactComponent };